import { useTheme as h, getSafeGutter as g, getSizeValue as a } from "@bedrock-layout/spacing-constants";
import { forwardRefWithAs as y } from "@bedrock-layout/type-utils";
import b from "react";
const w = {
  "1/4": "fraction:1/4",
  "1/3": "fraction:1/3",
  "1/2": "fraction:1/2",
  "2/3": "fraction:2/3",
  "3/4": "fraction:3/4",
  "auto-start": "auto 1fr",
  "auto-end": "1fr auto"
}, A = y(
  ({ as: n, fraction: t, gutter: i, minItemWidth: o, switchAt: r, style: s, ...c }, f) => {
    const e = h(), m = t && w[t] ? `fraction:${t}` : "", u = g(e, i), p = a(e, o) ?? o, l = a(e, r) ?? r, d = s ?? {}, S = n ?? "div";
    return /* @__PURE__ */ b.createElement(
      S,
      {
        ref: f,
        "data-bedrock-split": m,
        style: {
          ...d,
          "--gutter": u,
          "--minItemWidth": p,
          "--switchAt": l
        },
        ...c
      }
    );
  }
);
A.displayName = "Split";
export {
  A as Split
};
